// @flow
import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

import RowLayout from 'app/common/layouts/RowLayout'

import styles from './help-intro.module.scss';

/**
 *  Вступление для раздела помощи со ссылками на полезные материалы
 */

type Props = {
  questionsUrl?: string,
  instructionsUrl?: string,
}

const HelpIntro = ({ questionsUrl, instructionsUrl }: Props) => {
  const { t } = useTranslation('help')

  const solo = !questionsUrl || !instructionsUrl
  const linkTitleIns = t('link_title_instructions', 'Инструкции')
  const linkTitleFaq = t('link_title_faq', 'Вопрос-ответ')
  const evidentLinkProps = {
    className: styles.evidentLink,
    target: '_blank',
    rel: 'noopener noreferrer',
  }


  return (
    <RowLayout flex>
      <div className={styles.sign}>{'!'}</div>
      <div>
        {!solo
          && <Trans
            ns="help"
            i18nKey="intro_text"
            values={{ linkTitle1: linkTitleIns, linkTitle2: linkTitleFaq }}
          >
            {'Пожалуйста, убедитесь, что Ваша проблема не встречалась в разделах '}
            <a href={instructionsUrl} {...evidentLinkProps}>{'Инструкции'}</a>
            {' или '}
            <a href={questionsUrl} {...evidentLinkProps}>{'Вопрос-ответ'}</a>
            {', прежде чем создавать обращение в тех. поддержку. Скорее всего, решение уже существует — это поможет Вам быстрее разобраться с ситуацией. Спасибо!'}
          </Trans>}

        {solo
          && <Trans
            ns="help"
            i18nKey="intro_text_solo"
            values={{ linkTitle: instructionsUrl ? linkTitleIns : linkTitleFaq }}
          >
            {'Пожалуйста, убедитесь, что Ваша проблема не встречалась в разделe '}
            <a href={questionsUrl || instructionsUrl} {...evidentLinkProps}>{'Перейти'}</a>
            {', прежде чем создавать обращение в тех. поддержку. Скорее всего, решение уже существует — это поможет Вам быстрее разобраться с ситуацией. Спасибо!'}
          </Trans>}
      </div>
    </RowLayout>
  )
}

export default HelpIntro
